import { Suspense, ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

interface LazyPageWrapperProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const defaultFallback = (
  <div className="container mx-auto px-4 py-8 space-y-6">
    <Skeleton className="h-8 w-1/3" />
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="space-y-4">
          <Skeleton className="h-48 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      ))}
    </div>
  </div>
);

export function LazyPageWrapper({ children, fallback = defaultFallback }: LazyPageWrapperProps) {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  );
}